"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.create = create;
exports.normalizeLang = normalizeLang;
exports.detectLanguage = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _overrideSettings = require("../shared/override-settings/overrideSettings");

function create() {
  var detectors = {};
  var initOptions;
  var detectOptions;
  return {
    type: 'languageDetector',
    async: true,
    init: function init(_services, i18nextDetectOptions, i18nextOptions) {
      detectOptions = i18nextDetectOptions;
      initOptions = i18nextOptions;
    },
    detect: function detect(callback) {
      detectLanguage(detectors, detectOptions, initOptions).then(function (lng) {
        return callback(lng);
      }).catch(function (error) {
        var telemeryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');
        telemeryEmitter === null || telemeryEmitter === void 0 ? void 0 : telemeryEmitter.error('language/detect/failed', {
          error: "Failed to detect language: ".concat(error)
        });
      });
    },
    addDetector: function addDetector(newDetectors) {
      (0, _forEach.default)(newDetectors).call(newDetectors, function (detector) {
        detectors[detector.name] = detector;
      });
    },
    cacheUserLanguage: function cacheUserLanguage(_lng) {// Leave the function body empty for now
    }
  };
}

function normalizeLang(lng) {
  var normalizedLng = lng === null || lng === void 0 ? void 0 : lng.toString().replace(/_/g, '-');

  if (!(0, _includes.default)(normalizedLng).call(normalizedLng, '-')) {
    normalizedLng = normalizedLng.toLowerCase();
  }

  return normalizedLng;
}

var detectLanguage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(detectors, detectOptions, i18nextOptions) {
    var _context;

    var promises, results, detected, found;
    return _regenerator.default.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            promises = (0, _map.default)(_context = detectOptions.order).call(_context, /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(option) {
                return _regenerator.default.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!detectors[option]) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return", detectors[option].lookup(detectOptions));

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()); // Use async await to make sure we detect the language in order
            // This is because in Msal we get the token asynchronously to detect the language

            _context3.next = 3;
            return _promise.default.all(promises);

          case 3:
            results = _context3.sent;
            detected = [];
            (0, _forEach.default)(results).call(results, function (lng) {
              if (lng && typeof lng === 'string') {
                lng = [lng];
              }

              if (lng) {
                detected = (0, _concat.default)(detected).call(detected, lng);
              }
            }); // Find the first detected language

            found = '';
            (0, _forEach.default)(detected).call(detected, function (lng) {
              if (found !== '') {
                return;
              }

              found = lng;
            });
            return _context3.abrupt("return", found !== '' ? normalizeLang(found) : i18nextOptions.fallbackLng);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function detectLanguage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.detectLanguage = detectLanguage;